import { defineStore } from 'pinia'
import { ws } from '@/socket'

export const useMessagesStore = defineStore('messages', {
  state: () => ({
    messages: [],
    messageBits: [],
    messageLoading: false,
  }),
  getters: {
    getMessage() {
      return this.messageBits.join('')
    },
    getAllMessages() {
      return this.messages
    },
    getMessageLoading() {
      return this.messageLoading
    },
  },
  actions: {
    bindEvents() {
      ws.onmessage = (msg) => {
        const msgObject = JSON.parse(msg.data)
        switch (msgObject?.event) {
          case 'message:created':
            this.messageBits = []
            break
          case 'message:bits':
            this.messageBits.push(msgObject.data)
            this.messages = [
              ...this.messages.slice(0, -1),
              {
                role: 'assistant',
                content: this.messageBits.join(''),
              },
            ]
            break
          default:
            break
        }
      }
    },
    setMessages(messages) {
      this.messages = messages
    },
    replaceLastMessage(message) {
      this.messages = [...this.messages.slice(0, -1), message]
    },
    setMessageLoading(loading) {
      this.messageLoading = loading
    },
    setMessageFeedback(message, sentiment) {
      const index = this.messages.findIndex(
        (m) => m.message_id === message.message_id
      )
      this.messages[index] = { ...message, sentiment }
    },
  },
})
